import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import IconCancel from '@material-ui/icons/Cancel';
import CheckIcon from '@material-ui/icons/Check';
import * as React from 'react';
import {
  ArrayField,
  Datagrid,
  DateField,
  EditButton,
  FunctionField,
  Show,
  SimpleShowLayout,
  TextField,
} from 'react-admin';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import myDataProvider from 'src/MyDataProvider';

const useStyles = makeStyles({
  divFlex: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '4vh',
  },
  textField: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingBottom: 0,
    marginTop: '10px',
    fontWeight: 500,
    height: '30px',
    border: 'none',
    borderRadius: '8px',
  },
  button: {
    justifyContent: 'flex-end',
  },
  box: {
    width: '100%',
  },
});

const postRowStyle = (record) => {
  switch (record.status) {
  case 'RELEASED':
    return { backgroundColor: 'green' };
  case 'RETAINED':
    return { backgroundColor: '#a2282a' };
  default:
    return { backgroundColor: 'null' };
  }
};

const CommentEditButton = ({ record }) => (
  <EditButton
    basePath="/shipments"
    label="Edit"
    resource="shipments"
    record={record}
  />
);

export const ManifestShow = (props) => {
  const history = useHistory();
  const classes = useStyles();
  const handleClick = async (e) => {
    e.preventDefault();
    const resp = await myDataProvider.getOne(
      `manifest/${e.target.children[0].value}`,
      props,
    );

    history.push(`/shipments/${resp.data.id}`);
  };

  const handleRedirect = async () => {
    history.push(`${props.basePath}/${props.id}`);
  };

  const ManifestStatus = useSelector(
    (data) => data.admin.resources.manifest.data[props.id],
  );

  return (
    <>
      <Box justifyContent="space-between" display="flex">
        <form onSubmit={handleClick}>
          <input
            className={classes.textField}
            source="id"
            placeholder="Tracking number"
            resettable
            alwaysOn
          />
        </form>
        <EditButton
          basePath="/manifest"
          label="Upload second manifest"
          resource="manifest"
          onClick={handleRedirect}
          className={classes.button}
        />
      </Box>
      <Show actions={false} {...props}>
        <>
          <SimpleShowLayout className={classes.divFlex}>
            <TextField source="manifestNumber" label="Manifest number" />
            <TextField source="awb" label="Awb" />
            <TextField label="Status" source="status" />
            <TextField label="Total items" source="totalItems" />
            <TextField label="Airline" source="airlines" />
            <TextField
              label="Destination country"
              source="destinationCountry"
            />
            <DateField label="Created" source="createdAt" />
            <DateField label="Updated" source="updatedAt" />
            <TextField label="Total weight (kg)" source="totalWeight" />
          </SimpleShowLayout>
          <ArrayField source="shipments">
            <Datagrid rowStyle={postRowStyle}>
              <TextField sortable={false} source="dni" label="Dni" />
              <TextField sortable={false} source="weight" label="Weight" />
              <TextField sortable={false} source="value" label="Value" />
              <TextField sortable={false} source="user" label="User" />
              <TextField sortable={false} source="phone" label="Phone" />
              <TextField sortable={false} source="taxes" label="Taxes" />
              <TextField sortable={false} source="status" label="Status" />
              {(ManifestStatus && ManifestStatus.status === 'UPDATED') ||
              (ManifestStatus && ManifestStatus.status === 'CLOSED') ? (
                  <FunctionField
                    label="Skypostal"
                    render={(record) =>
                      record.skypostalError || record.status === 'RECEIVED' ? (
                        <IconCancel style={{ color: 'red' }} />
                      ) : (
                        <CheckIcon />
                      )
                    }
                  />
                ) : (
                  <FunctionField label="Skypostal" render={() => 'NOTHING YET'} />
                )}
              <CommentEditButton />
            </Datagrid>
          </ArrayField>
        </>
      </Show>
    </>
  );
};
